<div class="text-right">
  <button class="alert alert-{{alertType}}" mat-button (click)="dismiss($event)">OK</button>
</div>
<div class="conteudo">
  @for (mensagem of dados; track mensagem) {
    <p>{{mensagem}}</p>
  }
</div>
